import { createQueryKeys } from '@lukemorales/query-key-factory';
import apiService from '@services/base/apiService';

export const berichtenQueries = createQueryKeys('news', {
  get: {
    queryKey: null,
    queryFn: () => apiService.apiClient.get<NewsItem[]>('/net/home/DisplayNews?nType=1&json=true'),
  },
});

export interface NewsItem {
  id: number | string;
  startdatum: string;
  titel: string;
  inhoud: string;
  kleur: string | null;
  urgent: boolean;
  categorie: string;
  bestanden?: Bestand[];
}

type Bestand = {
  naam: string;
  url: string;
};
